/* eslint-disable tss-unused-classes/unused-classes */
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => {
  const splitDialogPlaceholder = {
    opacity: 1,
    color: theme.palette.text.secondary,
    ...theme.typography.paragraphRegular,
  };

  return {
    splitDialogPlaceholderScope: {
      '& input::placeholder, & textarea::placeholder': splitDialogPlaceholder,
      '& input::-webkit-input-placeholder, & textarea::-webkit-input-placeholder': splitDialogPlaceholder,
      '& input::-moz-placeholder, & textarea::-moz-placeholder': splitDialogPlaceholder,
    },
    content: {
      flex: '1 1 auto',
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      padding: theme.spacing(0, 0, 0, 3),
      borderBottom: 'none',
      // Descendant (not direct child): `StdDialogContent` wraps children in `ErrorBoundary`.
      '& [data-split-scroll]': {
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        alignSelf: 'stretch',
        overflowX: 'hidden',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        '> div': {
          gap: theme.spacing(3),
        },
      },
    },
    contentInner: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
    },

    amountSection: {
      display: 'flex',
      flexDirection: 'column',
      flexShrink: 0,
      padding: theme.spacing(2, 3),
      overflow: 'hidden',
      borderBottom: `1px solid ${theme.palette.border.light}`,
      boxShadow: theme.shadows[12],
    },

    splitDialogContent: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      overflow: 'hidden',
      minHeight: 0,
    },
    seriesSplitSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    seriesSplitHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1.5),
    },
    seriesSplitHeaderLabel: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 0,
      flexShrink: 1,
    },
    seriesSplitHeaderText: {
      flexShrink: 0,
    },
    seriesSplitHeaderName: {
      color: theme.palette.text.secondary,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    seriesSplitHeaderDivider: {
      flex: 1,
    },
    seriesSplitHeaderActions: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      flexShrink: 0,
    },
    seriesSplitMore: {
      color: theme.palette.icon.main,
      width: 24,
      height: 24,
      padding: 0,
      backgroundColor: theme.palette.background.default,
    },
    seriesSplitRemove: {
      color: theme.palette.icon.main,
      width: 24,
      height: 24,
      padding: 0,
      backgroundColor: theme.palette.background.default,
    },
    splitRowAttributes: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    amountDiv: {
      marginRight: 'auto',
      width: '50%',
    },
    amountDivSeries: {
      width: 310,
      flexShrink: 0,
    },
    amountField: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      '> div': {
        width: '100%',
      },
    },
    amountRowSeries: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
    },
    splitFooter: {
      flexShrink: 0,
      width: '100%',
      boxSizing: 'border-box',
    },
    bottomButtons: {
      flexShrink: 0,
      padding: theme.spacing(3),
    },
    buttonBorder: {
      border: `1px solid ${theme.palette.primary.main}`,
      padding: theme.spacing(1, 2),
    },
    cancelButton: {
      padding: theme.spacing(1, 2),
    },
    leftToSplitCol: {
      minWidth: 140,
      textAlign: 'end',
    },
    catRow: {
      display: 'flex',
      width: '100%',
    },
    catRowSeries: {
      gap: theme.spacing(1.5),
      '& > div': {
        margin: theme.spacing(0),
      },
      '& > div:first-child': {
        flex: 1,
      },
      '& .MuiFormControl-root': {
        marginTop: 0,
        marginBottom: 0,
      },
      '&& .MuiFilledInput-root': {
        height: 48,
        minHeight: 48,
        maxHeight: 48,
        boxSizing: 'border-box',
      },
    },
    tagsRow: {
      width: '100%',
      '.MuiFormControl-root': {
        margin: 0,
      },
      '& .MuiFilledInput-root': {
        minHeight: 48,
        boxSizing: 'border-box',
        alignItems: 'center',
        backgroundColor: theme.palette.background.default,
      },
      '& .MuiFilledInput-input::placeholder': {
        ...theme.typography.bodyRegular,
        color: theme.palette.text.secondary,
        opacity: 1,
      },
    },
    splitMetaRow: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1.5),
      flexWrap: 'nowrap',
      width: '100%',
    },
    /** Series note is multiline — top-align with exclusions control */
    splitMetaRowSeries: {
      alignItems: 'flex-start',
    },
    clientProjectSelect: {},
    deleteButton: {
      color: theme.palette.error.main,
      padding: theme.spacing(1, 2),
    },
    headerData: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    headerText: {
      paddingBottom: theme.spacing(1.5),
    },
    helpButton: {
      width: 36,
      height: 36,
      border: `1px solid ${theme.palette.border.light}`,
      borderRadius: 8,
      flexShrink: 0,
    },
    leftToSplitButton: {
      marginLeft: 8,
    },
    leftToSplitDiv: {
      justifyContent: 'end',
      display: 'flex',
      alignItems: 'center',
    },
    splitCat: {
      minWidth: 0,
      width: '100%',
    },
    splitCatOverflow: {
      flex: 1,
    },
    splitTag: {
      minWidth: 0,
      width: '100%',
    },
    splitAmount: {
      maxWidth: 160,
      width: '100%',
      '& > div:first-child': {
        margin: theme.spacing(0),
      },
    },
    splitAmountOverflowSpan: {
      // Let overflow amount use the space normally occupied by the remove "X" column.
      gridColumn: '2 / 4',
      maxWidth: 'none',
      width: '100%',
    },
    splitAmountOverflowSeriesSpan: {
      gridColumn: 2,
    },
    splitAmountSeries: {
      '& input': {
        textAlign: 'left',
      },
    },
    splitAmountSeriesOverflow: {
      flex: 0,
      minWidth: 160,
      padding: theme.spacing(0.125, 0),
      '& .MuiFilledInput-root': {
        borderRadius: theme.shape.borderRadius * 3,
        backgroundColor: theme.palette.background.paper,
      },
      '& input': {
        textAlign: 'left',
      },
    },
    splitRemove: {
      gridColumn: 4,
      justifySelf: 'end',
      width: 24,
      height: 24,
      color: theme.palette.icon.main,
      alignSelf: 'center',
    },
    splitExclusionSettings: {
      flex: 0,
      minWidth: 140,
    },
    splitNotesField: {
      flex: 1,
      minWidth: 0,
      minHeight: 48,
      '& .MuiFilledInput-root': {
        minHeight: 48,
        alignItems: 'center',
        borderRadius: theme.shape.borderRadius * 3,
        backgroundColor: theme.palette.background.default,
      },
      '& .MuiFilledInput-input': {
        textAlign: 'left',
        padding: 0,
        height: '24px',
      },
    },
    splitOptionsMenuPaper: {
      padding: theme.spacing(1),
      borderRadius: theme.shape.borderRadius * 2.5,
      minWidth: 194,
    },
    splitOptionsMenuCheck: {
      minWidth: 24,
      color: theme.palette.primary.main,
    },
    splitOptionsMenuItemSelected: {
      color: theme.palette.primary.main,
    },
    menu: {
      marginLeft: 8,
      height: 20,
      borderRadius: '45%',
      '&:hover': {
        backgroundColor: theme.palette.background.default,
      },
    },
    menuRoot: {
      padding: 8,
      width: 320,
    },
    newTransactionText: {
      alignSelf: 'start',
      marginTop: 2,
      marginRight: 'auto',
    },
    positive: {
      color: theme.palette.amount.positive,
    },
    success: {
      color: theme.palette.success.dark,
      height: 18,
    },
    textWrap: {
      textWrap: 'wrap',
      color: theme.palette.text.secondary,
      whiteSpace: 'normal',
    },
    splitRows: {
      display: 'flex',
      flexDirection: 'column',
      overflowX: 'hidden',
      gap: theme.spacing(3),
      padding: theme.spacing(3, 3, 0, 0),
    },
    splitValidationError: {
      paddingTop: theme.spacing(1),
    },
  };
});
